<template>
  <section class="page-wrapper">
    <p v-if="props.configData?.Header" class="heading-xs mb-24">
      {{ configData.Header }}
    </p>
    <div
      class="mt-16 mb-24 grid gap-16"
      :class="{
        'grid-cols-2 md:grid-cols-3 lg:grid-cols-4 2xl:grid-cols-5':
          variant === 'product',
        'grid-cols-2 md:grid-cols-4 lg:grid-cols-5': variant === 'subscription',
        '[&>*:nth-last-child(1):nth-child(3)]:col-span-full':
          (configData?.Cards || []).length === 3,
        'md:[&>*:nth-last-child(1):nth-child(3)]:col-span-1':
          (configData?.Cards || []).length === 3,
        'md:[&>*:nth-last-child(1):nth-child(4)]:col-span-full':
          variant === 'product' && (configData?.Cards || []).length === 4,
        'lg:[&>*:nth-last-child(1):nth-child(4)]:col-span-1':
          variant === 'product' && (configData?.Cards || []).length === 4,
        '[&>*:nth-last-child(1):nth-child(5)]:col-span-full':
          (configData?.Cards || []).length === 5,
        'md:[&>*:nth-last-child(1):nth-child(5)]:col-span-1':
          variant === 'product' && (configData?.Cards || []).length === 5,
        'lg:[&>*:nth-last-child(1):nth-child(5)]:col-span-full':
          variant === 'product' && (configData?.Cards || []).length === 5,
        '2xl:[&>*:nth-last-child(1):nth-child(5)]:col-span-1':
          variant === 'product' && (configData?.Cards || []).length === 5,
        'md:[&>*:nth-last-child(1):nth-child(4)]:col-span-1':
          variant === 'subscription' && (configData?.Cards || []).length === 4,
        'md:[&>*:nth-last-child(1):nth-child(5)]:col-span-full':
          variant === 'subscription' && (configData?.Cards || []).length === 5,
        'lg:[&>*:nth-last-child(1):nth-child(5)]:col-span-1':
          variant === 'subscription' && (configData?.Cards || []).length === 5,
      }"
    >
      <NuxtLink
        v-for="(card, index) in configData?.Cards || []"
        :key="card.Title"
        :to="card.Url"
        external
        :class="[
          'p-0',
          'no-underline',
          'min-h-[340px]',
          'rounded-lg',
          'border-sm',
          'border-transparent-black-300',
          'bg-seasonal-promotion-card',
          'dark:bg-transparent',
          'hover:dark:bg-transparent',
          'hover:bg-seasonal-promotion-card-hover',
          'hover:bg-[#afcbcb]',
          'dark:bg-seasonal-promotion-card-dark',
          'hover:dark:bg-seasonal-promotion-card-dark-hover',
          '[background-origin:border-box]',
          '[background-clip:padding-box,border-box]',
          '[box-shadow:inset_0_0_0_1px_rgba(255,255,255,0.15)]',
          `${zClassOfIndex(index)}`,
          'flex',
          'flex-col',
          'justify-between',
        ]"
      >
        <SeasonalDealsLinkToOtherPageCardBody
          v-if="isLinkToOtherProductsCard(card)"
          :card="card"
        />
        <SeasonalDealsProductCardBody
          v-else-if="variant === 'product'"
          :card="card"
        />
        <div v-else-if="variant === 'subscription'">
          <SeasonalDealsSubscriptionCardBody :card="card" />
        </div>

        <SeasonalDealsSubscriptionCardFooter
          v-if="variant === 'subscription' && !isLinkToOtherProductsCard(card)"
          :is-family-card="card.Title === 'Familj'"
          :card="card"
        />
      </NuxtLink>
    </div>
  </section>
</template>

<script lang="ts" setup>
import type { SeasonDealMarkupCard } from '~/models/seasonaldeals/SeasonalDealMarkupCard.model';

interface Props {
  variant: 'product' | 'subscription';
  configData: {
    Header?: string;
    Cards?: SeasonDealMarkupCard[];
  };
}
const props = defineProps<Props>();

const isLinkToOtherProductsCard = (card: SeasonDealMarkupCard) => {
  if (
    card.Title &&
    !card.MainPriceLabel &&
    !card.MainAllowanceLabel &&
    !card.MainProductImage
  ) {
    return true;
  }

  return false;
};

function zClassOfIndex(index: number): string {
  const reveresedIndex = (props.configData?.Cards || []).length - index;
  switch (reveresedIndex) {
    case 0:
      return 'z-0';
    case 1:
      return 'z-[1]';
    case 2:
      return 'z-[2]';
    case 3:
      return 'z-[3]';
    case 4:
      return 'z-[4]';
    case 5:
      return 'z-[5]';
    case 6:
      return 'z-[6]';
    default:
      return 'z-0';
  }
}
</script>

<style scoped></style>
